import { cloneDeep, isEmpty, pickBy } from "lodash";
import store from "src/_store/store"
import http from "src/_services/httpService";

import { $BASE_URL, ROLES, USER_ROLES } from "src/constants";
const apiUrl = $BASE_URL + '/api';
const commonEndpoint = `${apiUrl}/v1/order`;

const apiEndpoints = {
    [ROLES.admin]: apiUrl + "/v1/admin-panel/order",
    [ROLES.merchant]: apiUrl + "/v1/order",
    [ROLES.shippingCompany]: apiUrl + "/v1/order",
    [USER_ROLES.MERCHANT]: apiUrl + "/v1/order",
    driver: apiUrl + "/v1/order",
    user: apiUrl + "/v1/user/order",
}

const getGlobalFilterCriteria = (params, warehouseTypeArray = false) => {
    const state = store.getState()
    let customizations = cloneDeep(state?.entities?.customizations)
    let customizationsExistedData = pickBy(customizations, v => !isEmpty(v))
    if (!isEmpty(customizationsExistedData)) {
        if (!!customizationsExistedData?.warehouse) {
            if (warehouseTypeArray) {
                customizationsExistedData.warehouse = [customizationsExistedData?.warehouse?.id]
            } else {
                customizationsExistedData.warehouse = customizationsExistedData?.warehouse?.id
            }
        }
        return { ...params, ...customizationsExistedData }
    }
    return params
}

function getAllOrders(params) {
    return http.get(`${commonEndpoint}`, { params: getGlobalFilterCriteria(params) });
}

function getZonesAndConnectionsCountByStatus(payload) {
    let params = { ...payload }
    return http.get(`${commonEndpoint}/zones_orders`, { params: getGlobalFilterCriteria(params) });
}

function getOrdersBy_Id_OrderStatus({ Id, status, type }) {
    let params = { status }
    return http.get(`${commonEndpoint}/${type}/${Id}`, { params: getGlobalFilterCriteria(params) });
}
function getDriverOrders(id) {
    return http.get(`${commonEndpoint}/driver/${id}`);
}

function orderUrl(role, id) {
    return `${apiEndpoints[role]}/${id}`;
}

const createOrder = (role, order) => {
    return http.post(apiEndpoints[role], order);
}

const getOrders = (role) => {
    return http.get(apiEndpoints[role], { params: getGlobalFilterCriteria({}) });
}

const getOrder = (role, orderId) => {
    return http.get(orderUrl(role, orderId));
}

const getOrdersByFilter = (params) => {
    if (!!params?.page) {
        params.page = params.page + ''
    }
    if (!!params.limit) {
        params.limit = params.limit + ''
    }
    return http.post(apiUrl + "/v1/order/filter", getGlobalFilterCriteria(params, true));
}

const updateOrder = (role, orderId, order) => {
    return http.put(`${commonEndpoint}/${orderId}`, order);
}

const deleteOrder = orderId => {
    const url = `${commonEndpoint}/${orderId}`;
    return http.delete(url);
}

const assignDriversToOrders = (payload) => {
    //  const params = { orders, drivers }
    return http.post(
        `${commonEndpoint}/assign-drivers`,
        payload
    )
}

const assignDriverToOrder = (payload) => {
    //  const params = { orders, drivers }
    return http.post(
        `${commonEndpoint}/assign-driver`,
        payload
    )
}

const assignShippingCompanyToOrders = (payload) => {
    return http.post(
        `${commonEndpoint}/assign-shipping_company`,
        payload
    )
}
const assignSingleOrderToShippingCompany = ({ orderId, shippingCompany }) => {
    const params = { orderId, shippingCompany }
    return http.post(
        `${commonEndpoint}/assign-shipping_company/single_order`,
        params
    )
}


const importOrdersFromSpreadsheet = (role, params) => {
    return http.post(
        `${apiEndpoints[role]}/xls`,
        params
    );
}

const getNewOrdersForSubmerchant = (role, submerchantId) => {
    return http.get(`${apiEndpoints[role]}/new-for-submerchant?id=${submerchantId}`);
}

const getPrintableAWB = orders => {
    const params = { orders }
    // const options = { responseType: "blob" }
    return http.post(
        `${apiUrl}/v1/order/generate-pdf`,
        params,
        // options
    )
}

const resendLocationSms = orders => {
    const params = { orders }
    return http.post(
        `${commonEndpoint}/resend-location-sms`,
        params,
    )
}

const updateOrderAddressByUser = address => {
    const url = `${apiEndpoints['user']}/address`;
    return http.put(url, address)
}

const updateOrdersStatus = (role, payload) => {
    return http.put(`${apiEndpoints[role]}/update-orders-status`, payload);
}

const reorderFailedOrder = (payload) => {
    return http.post(`${apiUrl}/v1/order/re-order`, payload);
}

const getCompletedOrderCount = () => {
    return http.get(`${commonEndpoint}/new-orders-completed-count`);
}

const updateCompletedOrderCount = (id) => {
    return http.put(`${commonEndpoint}/new-order-completed/${id}`);
}

const getAddressFromNationalAddress = (params) => {
    return http.get(`${commonEndpoint}/national-address`, { params });
}

const getWarehouseOrders = (params, warehouseId) => {
    return http.get(`${commonEndpoint}/warehouse_orders/${warehouseId}`, { params });
}
const getWarehouseOrdersByFilter = (payload) => {
    return http.post(`${apiUrl}/v1/order/guard-filter`, getGlobalFilterCriteria(payload, true));
}
const sendExcelFileToEmail = (payload) => {
    return http.post(`${apiUrl}/v1/order/filterToXLS`, getGlobalFilterCriteria(payload, true));
}
const rescheduleOrder = (payload) => {
    return http.put(`${apiUrl}/v1/user/order/delivery-date`, payload);
}
const reviewDriver = (payload) => {
    return http.post(`${apiUrl}/v1/review`, payload);
}
const complaintDriver = (payload) => {
    return http.post(`${apiUrl}/v1/complaint`, payload);
}

const OrderService = {
    createOrder,
    getOrders,
    getOrder,
    updateOrder,
    deleteOrder,
    assignDriversToOrders,
    assignShippingCompanyToOrders,
    getPrintableAWB,
    importOrdersFromSpreadsheet,
    getNewOrdersForSubmerchant,
    resendLocationSms,
    getOrdersByFilter,
    updateOrderAddressByUser,
    updateOrdersStatus,
    reorderFailedOrder,
    getZonesAndConnectionsCountByStatus,
    getOrdersBy_Id_OrderStatus,
    getDriverOrders,
    assignDriverToOrder,
    assignSingleOrderToShippingCompany,
    getCompletedOrderCount,
    updateCompletedOrderCount,
    getAddressFromNationalAddress,
    getAllOrders,
    getWarehouseOrders,
    getWarehouseOrdersByFilter,
    sendExcelFileToEmail,
    rescheduleOrder,
    reviewDriver,
    complaintDriver
};

export default OrderService;
